import React, { memo } from "react";

import { translation } from "../../utils";
import { AboutMe } from "./components/aboutMe";
import { ScrollDownAnimation } from "./components/scrollDownAnimation";
import { Header } from "../../components/Header";
import { Work } from './components/work';

import videoBG from "../../assets/background/landing.mp4";
import videoPosterBG from "../../assets/background/landing.jpeg";
import { Footer } from "../../components/Footer/Footer";

export const Home = memo(() => {

  return (
    <>
      <Header />
      <article className='Landing'>
        <section className="container" style={{ height: 'calc(100% - 48px)' }}>
          <div className='fullsize landing-grid'>
            <p className="display">
              {translation.landing.title}
              <span className="gradient-text-secondary">
                {translation.landing.highlightedText}
              </span>
            </p>
            <div className="scroll-animation-container flex flex-center fullsize" style={{ height: 'var(--scale-10xl)' }}>
              <ScrollDownAnimation />
            </div>
          </div>
        </section>
        <video
          src={videoBG}
          autoPlay
          loop
          muted
          poster={videoPosterBG}
          playsInline={true}
          disablePictureInPicture={true}
        />
      </article>
      <article id="work" className="sub-section" style={{ backgroundColor: 'var(--surface-primary-contrast)', color: 'var(--text-primary-contrast)' }}>
        <section className="container container-flex" style={{ alignItems: 'flex-start' }}>
          <div className="display">MY WORK</div>
          <Work />
        </section>
      </article>
      <article id="about" className="sub-section" style={{ backgroundColor: 'var(--surface-primary)', color: 'var(--text-primary)' }}>
        <section className='container container-flex' style={{ alignItems: 'flex-start' }}>
          <div className="display">ABOUT ME</div>
          <AboutMe />
        </section>
      </article>
      <Footer />
    </>
  );
});
